import * as Sentry from '@sentry/react'
import { env } from '@/config/env'

/**
 * Initialize Sentry. No-op if VITE_SENTRY_DSN is empty (local/dev default).
 */
export function initSentry() {
  if (!env.sentry.dsn) return

  Sentry.init({
    dsn: env.sentry.dsn,
    environment: env.sentry.environment,
    tracesSampleRate: env.isProd ? 0.1 : 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: env.isProd ? 1 : 0,
  })
}

export { Sentry }
